
import { Component, Vue, Prop } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import AppButtonBordeless from '@/components/AppButtonBordeless.vue'

type WarningType =  'warning' | 'error' | 'success'

@Component({
    components: {
        AppButtonBordeless,
        FontAwesomeIcon,
    },
})
export default class AppWarning extends Vue {
    @Prop() private text!: string
    @Prop() private type!: WarningType
    @Prop() private showButton!: boolean
    @Prop() private buttonText!: string
    @Prop() private buttonAction!: () => any

    public stopPropagation(e: Event) {
        e.stopPropagation()
    }

    get getClassColor() {
        if (this.type === 'warning') {
            return 'yellow'
        }
        if (this.type === 'error') {
            return 'red'
        }
        return 'green'
    }
}
